import { useSyncExternalStore } from "react"

/** Tailwind `lg` — the breakpoint where Battery-Only Proposal cards go two-column. */
const DESKTOP_MEDIA_QUERY = `(min-width: 1024px)`

const canMatchMedia = (): boolean => typeof window.matchMedia === `function`

const subscribe = (callback: () => void): (() => void) => {
  if (!canMatchMedia()) {
    return () => undefined
  }
  const mediaQuery = window.matchMedia(DESKTOP_MEDIA_QUERY)
  mediaQuery.addEventListener(`change`, callback)

  return () => {
    mediaQuery.removeEventListener(`change`, callback)
  }
}

// Environments without matchMedia (some DOM shims) get the desktop layout.
const getSnapshot = (): boolean =>
  canMatchMedia() ? window.matchMedia(DESKTOP_MEDIA_QUERY).matches : true

/** True at the `lg` breakpoint and up. Mobile-only affordances render when false. */
export const useDesktopViewport = (): boolean =>
  useSyncExternalStore(subscribe, getSnapshot, () => true)
